import { minPasswordLength, passwordMinCharsPerClass, passwordMinClasses } from '@gonfalon/constants/constants';
// eslint-disable-next-line no-restricted-imports
import { Record } from '@gonfalon/immutable-shim/immutableShim';
import {
  checkPasswordCharacters,
  isEmail,
  isLength,
  isNotEmpty,
  matches,
  optional,
  validateRecord,
} from '@gonfalon/legacy-form-validation/validationUtils';

import { PROFILE_NAME_MAX_LENGTH } from '#utils/accounts/accountTypes';

export class InvitationDetails extends Record({
  firstName: '',
  lastName: '',
  email: '',
  password: '',
}) {
  validate() {
    return validateRecord(
      this,
      isNotEmpty('firstName'),
      isLength(0, PROFILE_NAME_MAX_LENGTH)('firstName'),
      isNotEmpty('lastName'),
      isLength(0, PROFILE_NAME_MAX_LENGTH)('lastName'),
      isLength(minPasswordLength())('password'),
      checkPasswordCharacters({
        requiredCharCountPerClass: passwordMinCharsPerClass(),
        requiredClassCount: passwordMinClasses(),
      })('password'),
    );
  }
}

export type PasswordUpdateProps = {
  current: string;
  password: string;
  confirm: string;
};

const PasswordUpdateProps = {
  current: '',
  password: '',
  confirm: '',
};

export class PasswordUpdate extends Record<PasswordUpdateProps>(PasswordUpdateProps) {
  validate() {
    return validateRecord(
      this,
      isLength(minPasswordLength())('password'),
      checkPasswordCharacters({
        requiredCharCountPerClass: passwordMinCharsPerClass(),
        requiredClassCount: passwordMinClasses(),
      })('password'),
      isNotEmpty('current'),
      isNotEmpty('password'),
      isNotEmpty('confirm'),
      matches('password')('confirm'),
    );
  }
}

export class NewJoinTeamRequest extends Record({
  firstName: '',
  lastName: '',
  username: '',
  adminEmail: '',
}) {
  validate() {
    return validateRecord(
      this,
      isNotEmpty('username'),
      isEmail('username'),
      isNotEmpty('adminEmail'),
      isEmail('adminEmail'),
      optional(isNotEmpty)('firstName'),
      optional(isNotEmpty)('lastName'),
    );
  }
}

export function createInvitationDetails(props = {}) {
  return new InvitationDetails(props);
}

export function createPasswordUpdate(props = {}) {
  return new PasswordUpdate(props);
}

export function createNewJoinTeamRequest(props = {}) {
  return props instanceof NewJoinTeamRequest ? props : new NewJoinTeamRequest(props);
}
